// removed by extract-text-webpack-plugin
module.exports = {"answer-option__selected":"dh-dh-personlighetstest-answer-option__selected","selected":"dh-dh-personlighetstest-selected","answer-option":"dh-dh-personlighetstest-answer-option"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Answer.css
// module id = 60
// module chunks = 1